import React from "react";
import PropTypes from "prop-types";
import { Table } from "semantic-ui-react";

const TableItem = ({ headers, items, ...props }) => {
  return (
    <Table {...props}>
      <Table.Header>
        <Table.Row>
          {headers.map((header, index) => (
            <Table.HeaderCell
              key={index}
              style={{
                ...(header === "Houseberry School Score" && {
                  textAlign: "center",
                }),
              }}
            >
              {header}
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {items.length > 0 &&
          items.map((item, index) => (
            <Table.Row key={index}>
              {item.date ? <Table.Cell>{item.date}</Table.Cell> : null}
              {item.event ? <Table.Cell>{item.event}</Table.Cell> : null}
              {item.price ? (
                <Table.Cell>
                  ${parseFloat(item.price).toLocaleString()}
                </Table.Cell>
              ) : null}
              {item.school ? (
                <Table.Cell>
                  {item.schoolurl !== null && item.schoolurl !== "" ? (
                    <a
                      href={item.schoolurl}
                      className="neighborhood_school"
                      target="_blank"
                      title={item.school}
                    >
                      {item.school}
                    </a>
                  ) : (
                    item.school
                  )}{" "}
                </Table.Cell>
              ) : null}
              {item.rank ? <Table.Cell>{item.rank}</Table.Cell> : null}
              {item.type ? <Table.Cell>{item.type}</Table.Cell> : null}
              {item.grades ? <Table.Cell>{item.grades}</Table.Cell> : null}
              {item.rating ? (
                <Table.Cell>
                  <div className="gs-rating-with-label__rating">
                    <a
                      href={item.schoolurl}
                      className={`rs-gs-rating circle-rating--large ${
                        item.rating > 6
                          ? "circle-rating--blue"
                          : "circle-rating--blue"
                      }`}
                      target="_blank"
                      title={item.school}
                    >
                      {Number(item.rating)}
                      <span className="denominator">/10</span>
                    </a>
                  </div>
                </Table.Cell>
              ) : null}
              {item.testscorerating ? (
                <Table.Cell>
                  <div className="gs-rating-with-label__rating">
                    <a
                      href={item.schoolurl}
                      className={`rs-gs-rating circle-rating--large ${
                        item.testscorerating > 6
                          ? "circle-rating--blue"
                          : "circle-rating--blue"
                      }`}
                      target="_blank"
                      title={item.school}
                    >
                      {Number(item.testscorerating)}
                      <span className="denominator">/5</span>
                    </a>
                  </div>
                </Table.Cell>
              ) : null}
            </Table.Row>
          ))}
      </Table.Body>
    </Table>
  );
};

TableItem.propTypes = {
  headers: PropTypes.any,
  items: PropTypes.any,
};
export default TableItem;
